/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/bonz/layout/bonz.app.js
 * In commit: de125d9c0dbfa23a5f12f049c70f4e9e185a6932
 * For ticket: GRINS-1507
 */

const module = { name: 'bonz/layout/bonz.app', exports: {} }; const exports = module.exports;

// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);

import {
  Fandango_debugLog as debugLog,
  Fandango_xhr as xhr,
  fd_location_localeDetector as localeDetector,
  fd_location_regionSelector as regionSelector,
  fd_url_manager as links
} from '@grins/fd-modules/splits/onering-global';

function run() {
  checkDependencies(module.name, debugLog);
  xhr.init({ tokenURI: links.snapiGenerateCSRF() });
  regionSelector.init();
  localeDetector.init();
}

run();
export default {  };
